<template>
  <div>
    <v-layout justify-end>
      <v-flex class="xs12 md6 lg3 pl-2">
        <v-text-field
          v-model="search"
          placeholder="Search projects"
          append-icon="search"
          solo
          hide-details
          class="mb-2"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-tooltip v-if="permit.canCreateProject(auth.instance())"
      bottom
      fixed
      color="#fff"
      >
      <v-btn fab
        color="#0155a8"
        right
        bottom
        fixed
        medium
        slot="activator"
        class="mb-4"
        @click="newProject = !newProject"
        >
        <v-icon medium color="white">note_add</v-icon>
      </v-btn>
      <span class="black--text">Create new project</span>
    </v-tooltip>

    <v-container fluid grid-list-lg class="pa-0">
      <v-layout row wrap fill-height>
        <v-flex v-for="project in filteredProjects"
          :key="project.id"
          xs12 sm6 md4 lg3>
          <projectCard :project="project"></projectCard>
        </v-flex>
        <v-flex v-if="loading" class="text-xs-center grey--text">
          <h2 class="text-uppercase">
            Loading current projects....
          </h2>
          <h3>
            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </h3>
        </v-flex>
        <v-flex v-if="!loading && (projects.length === 0)" class="text-xs-center grey--text">
          <h2 class="text-uppercase">
            No projects
          </h2>
          <h3>
            To get started, <a @click="newProject = true">create a new project</a>
          </h3>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="newProject"
      max-width="500px"
      persistent
      >
      <projectNew></projectNew>
    </v-dialog>
  </div>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'
  import permissions from '@/utilities/permissions'

  import projectService from '@/services/project'
  import projectCard from '@/components/project/_card'
  import projectNew from '@/components/project/_new'

  export default {
    name: 'project-index',

    data () {
      return {
        auth: authentication,
        permit: permissions,
        projects: [],
        newProject: false,
        search: '',
        loading: false
      }
    },

    components: {
      'projectCard': projectCard,
      'projectNew': projectNew
    },

    mounted () {
      this.loadProjects()

      EventBus.$on('project-created', (payload) => {
        this.closeNewProject()
        if (payload) {
          this.projects.push(payload)
        }
      })

      EventBus.$on('project-updated', (payload) => {
        if (payload) {
          this.projects = this.projects.map((prj) => {
            if (parseInt(prj.id) === parseInt(payload.id)) {
              return payload
            } else {
              return prj
            }
          })
        }
      })

      EventBus.$on('project-deleted', (payload) => {
        if (payload) {
          this.projects = this.projects.filter(prj => parseInt(prj.id) !== parseInt(payload.id))
        }
      })
    },

    computed: {
      filteredProjects () {
        let subset = this.projects
        if (this.search != '') {
          let term = this.search.toLowerCase()
          subset = this.projects.filter(prj => prj.attributes.name.toLowerCase().includes(term) || (prj.attributes.description && prj.attributes.description.toLowerCase().includes(term)))
        }

        // sort the projects
        return subset.sort((a, b) => { return a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase()) })
      }
    },

    methods: {
      loadProjects () {
        this.loading = true
        projectService.index(
          (data) => {
            this.projects = data
            this.loading = false
          },
          (err) => {
            console.log(err)
          }
        )
      },

      closeNewProject () {
        this.newProject = false
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/index.vue